var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[(_vm.n != 5)?_c('path',{attrs:{"fill":_vm.fillLocal || _vm.fill || _vm.fillDefault,"stroke":"black","stroke-width":"3","d":_vm.d},on:{"click":function($event){$event.stopPropagation();
            _vm.seleccionado = !_vm.seleccionado;
            _vm.$emit('seleccionado');}}}):_c('ellipse',{attrs:{"stroke":"black","ry":"90","rx":"90","cy":"202.95313","cx":"203.33333","stroke-opacity":"null","stroke-width":"3","fill":_vm.fillLocal || _vm.fill || _vm.fillDefault},on:{"click":function($event){$event.stopPropagation();
            _vm.seleccionado = !_vm.seleccionado;
            _vm.$emit('seleccionado');}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }